import { Enum, EnumType } from 'ts-jenum';

@Enum<SamwinSkillTypeEnum>('value')
export class SamwinSkillTypeEnum extends EnumType<SamwinSkillTypeEnum>() {
   static readonly CALLING = new SamwinSkillTypeEnum(0);
   static readonly MAILING = new SamwinSkillTypeEnum(1);

   constructor(public value: number) {
      super();
   }
}
